<template>
    <div>
        <addnav :title="title" @onBack="onBack" @doclick="doclick"></addnav>
        <div class="ipts">
            <van-field
                v-model="model.content"
                rows="10"
                autosize
                type="textarea"
                maxlength="500"
                :placeholder="placeholder"
                show-word-limit
                clearable
            />
        </div>
        <!-- <div class="fuploader">
            <van-uploader v-model="fileList" :after-read="afterRead" @delete="deletefile"   multiple :max-count="9" />
        </div> -->
        <van-popup
            v-model="pshow"
            close-on-popstate
            position="bottom"
            :style="{ height: '55%' }"
        >
            <VEmojiPicker    style="width:100%;" :showSearch="false"   @select="selectEmoji" />
            <div class="rdelte" @click.stop="deleteindex">
                <van-icon name="close" />
            </div>
        </van-popup>
        <div class="mfooter">
           <van-icon class="icon-left" name="smile-o" @click="pshow=true" :size="20" />
        </div>
        
    </div>
</template>
<script>
import VEmojiPicker,{ emojisDefault, categoriesDefault } from 'v-emoji-picker';
export default {
    components: {
        VEmojiPicker
    },
    data(){
        return{
            title:'评论',
            message1:'',
            pshow:false,
            index:0,
            fileList:[],
            placeholder:'我也说一句',
            model:{
                topicId:undefined,
                content:'',
                replyCommentId:undefined,
                replyDealerId:undefined,
                replyMemberPersonalId:undefined,
                topicImgs:[]
            }
        }
    },
    created(){
        var query=this.$route.query;
        
        if(query.item)
        {
            var item=JSON.parse(query.item);
            console.log(item);
            this.model.replyCommentId=item.id;
            if(item.dealerId&&item.replyCommentId)
            {
                this.model.replyDealerId=item.dealerId;
                this.model.replyCommentId=item.replyCommentId;
                this.model.replyMemberPersonalId=item.memberPersonalId;
            }
            
            
            if(item.nick)
            {
                this.placeholder="回复"+item.nick+":";
            }
            this.title="回复评论";
            this.model.topicId=item.topicId;
        }
        else
        {
            this.model.topicId=query.topicId;
        }
        //设置创建的url地址
        
        console.log(this.model);
    },
    mounted(){
        
    },
    methods: {
         afterRead(file) {
            console.log(file);
            var nfilelist=[];
            if(Array.isArray(file))
            {
                nfilelist=file;
            }
            else
            {
                nfilelist.push(file);
            }
            var formData = new FormData();
            nfilelist.forEach(y=>
            {
                formData.append("file",y.file);
            })
            this.ajax
                .post("/File/SaveCatePic", formData)
                .then((x) => {
                    x.result.data.forEach(y=>{
                        var oj={
                            pathImg:y,
                        }
                        this.model.topicImgs.push(oj);
                    })
                })
                .catch(() => {
                    
                });
        },
        deletefile(file,index){
            console.log(this.model.topicImgs);
            this.model.topicImgs.splice(index.index, 1);
            console.log(this.model.topicImgs);
        },
        onBack(){
            if(!this.model.title&&!this.model.content)
            {
                this.$router.back(-1);
            }
            else
            {
                this.$dialog.confirm({title:'提示',message:'内容未发布,确定放弃并返回'}).then(x=>{
                    this.$router.back(-1);
                })
            }
            
        },
        doclick(){
            this.addtoppic();
        },
        addtoppic()
        {
            if(!this.model.content)
            {
                this.$toast("请输入回答内容");
                return;
            }
            this.ajax.post('/api/services/app/PhoneTopic/AddTopicComment',this.model).then(x=>
            {
                this.$toast("创建成功");
                this.$router.back(-1);
            }).catch(x=>
            {
                this.$toast("创建失败");
            })
        },
        deleteindex(){
          this.model.content=this.setmessage(this.model.content);
        },
        setmessage(val)
        {
            var ok=1;
            if(val)
            {
                if(val.length>1)
                {
                    if(this.isEmojiCharacter(val.substring(val.length-2))){
                        ok=2;
                    }
                }
                return val.substring(0,val.length-ok);
            }
           
            return "";
        },
        isEmojiCharacter(substring) {
            for ( var i = 0; i < substring.length; i++) {
                var hs = substring.charCodeAt(i);
                if (0xd800 <= hs && hs <= 0xdbff) {
                    if (substring.length > 1) {
                        var ls = substring.charCodeAt(i + 1);
                        var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
                        if (0x1d000 <= uc && uc <= 0x1f77f) {
                            return true;
                        }
                    }
                } else if (substring.length > 1) {
                    var ls = substring.charCodeAt(i + 1);
                    if (ls == 0x20e3) {
                        return true;
                    }
                } else {
                    if (0x2100 <= hs && hs <= 0x27ff) {
                        return true;
                    } else if (0x2B05 <= hs && hs <= 0x2b07) {
                        return true;
                    } else if (0x2934 <= hs && hs <= 0x2935) {
                        return true;
                    } else if (0x3297 <= hs && hs <= 0x3299) {
                        return true;
                    } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030
                            || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b
                            || hs == 0x2b50) {
                        return true;
                    }
                }
            }
        },
        selectEmoji(emoji) {
            this.model.content+=emoji.data;
        }
    }

}
</script>
<style lang="scss" scoped>
.mfooter{
    position: fixed;
    bottom: 0;
    height: 40px;
    left: 0;
    right: 0;
    background-color: #fff;
    line-height: 55px;
}
.icon-left{
    margin-left:10px;
}
.rdelte{
    position: fixed;
    bottom: 5px;
    right: 0;
    width: 30px;
    height: 30px;
    background-color: #ffffffa1;
    line-height: 37.5px;
    text-align: center;
}
.fuploader{
    background-color: #fff;
}
</style>